import { render, staticRenderFns } from "./PT410MemberTdkDetailsParts.vue?vue&type=template&id=7de260a7&"
import script from "./PT410MemberTdkDetailsParts.vue?vue&type=script&lang=js&"
export * from "./PT410MemberTdkDetailsParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports